export const STUDENTS = 'school/school-detail/instead/STUDENTS';
export const TEXTAREA = 'school/school-detail/instead/TEXTAREA';
export const STUDENT_PHONE = 'school/school-detail/instead/STUDENT_PHONE';




// WEBPACK FOOTER //
// ./src/store/modules/school/school-detail/instead/types.js